import { Plugin } from 'chart.js';

const transparent = 'rgb(0,0,0,0)';

export const tooltipColorNormalizer: Plugin = {

  id: 'tooltipColorNormalizer',

  beforeTooltipDraw(
    _,
    args,
    options: { disabled?: boolean; },
  ): void {

    if (options.disabled) {
      return;
    }

    const tooltip = args.tooltip;

    if (!tooltip) {
      return;
    }

    (tooltip.options.multiKeyBackground as any) = transparent;

    tooltip.labelColors.forEach((labelColor) => {

      if (labelColor) {
        labelColor.borderColor = transparent;
      }
    });
  },
};
